import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { GenericFormPage, GenericDetailPage } from '../../../components/generic';
import { useAccCompany, AccCompany } from './useData';
import {
  moduleConfig,
  getDetailSections,
  getStatusBadges,
  getInitialFormData,
  mapItemToFormData,
} from './config';

export { default as List } from './List';

export const Form: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const editId = id && id !== 'new' ? parseInt(id, 10) : NaN;
  const isEdit = Number.isInteger(editId);
  const { item, isLoading: loadingItem } = useAccCompany(isEdit ? editId : 0);

  const config = useMemo(() => {
    const base = { ...moduleConfig, getInitialFormData, mapItemToFormData };
    return {
      ...base,
      formLayout: {
        ...base.formLayout,
        sections: base.formLayout.sections.map((section) => ({
          ...section,
          defaultCollapsed: false,
        })),
      },
    };
  }, []);

  if (isEdit && loadingItem) {
    return (
      <div className="flex items-center justify-center flex-1 min-h-[240px] text-sm text-gray-500">
        Loading…
      </div>
    );
  }

  return <GenericFormPage<AccCompany> useData={useAccCompany} config={config} />;
};

export const Detail: React.FC = () => (
  <GenericDetailPage<AccCompany>
    useData={useAccCompany}
    config={{ ...moduleConfig, getDetailSections, getStatusBadges }}
  />
);
